export default __webpack_public_path__ + "static/media/Mark-5-HUD-Pop-Up (Process).3022adda.jpg";